import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
} from '@app/data/widget-config-templates/basic-cartesian-chart';
export const UaWaiowekaAtCableway: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b'],
    grid: {
      top: '25%',
      left: '8%',
      right: '8%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Rainfall\nmm',
        position: 'right',
        inverse: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00b1d8',
          },
        },
        axisLabel: {
          color: '#00b1d8',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Flow',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Rainfall',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
        emphasis: {
          focus: 'series',
        },
        lineStyle: {
          width: 1,
        },
        markArea: {
          silent: true,
          itemStyle: {
            opacity: 0.3,
          },
        },
      },
    ],
  },
  dataConfig: {
    title: 'UA - Rainfall and Relative Water Level: Waioweka at Cableway',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_waioweka_at_cableway',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Water Flow',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_waioweka_at_cableway',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Rainfall',
      },
    ],
  },
};

export const AnalyteWhenuaOmaukora: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'E. coli\nCFU/100mL',
        position: 'left',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'E. coli',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WHENUA - Land Cover and Wai: Omaukora at Wairata',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_omaukora_at_wairata',
        analyteIdentifier: 'e.-coli',
        valueField: 'avg',
        label: 'E. coli',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_omaukora_at_wairata',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

export const TaiaoOpotikiHarbour: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'E. coli\ncfu/100mL',
        position: 'left',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'N\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'P\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temperature',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'E. coli',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
  dataConfig: {
    title: 'TAIAO - Ecosystem Health: Coastal Ōpōtiki Harbour',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temperature',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'e.-coli',
        valueField: 'avg',
        label: 'E. coli',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'total-kjeldahl-nitrogen',
        valueField: 'avg',
        label: 'Total Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
};

export const AnalyteWaiOpotikiEstuaryAtKukumoa: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Black\nDisk\nm',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Dissolved\nOxygen\ng/m³',
        position: 'right',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temperature',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Black Disk',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Oxygen in Field',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Opotiki Estuary at Kukumoa',
    widgetId: 4,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temperature',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'black-disk',
        valueField: 'avg',
        label: 'Black Disk',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'dissolved-oxygen-in-field',
        valueField: 'avg',
        label: 'Dissolved Oxygen in Field',
      },
    ],
  },
};

export const AnalyteWaiOtaraRiver: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Black\nDisk\nm',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Dissolved\nOxygen\ng/m³',
        position: 'right',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temperature',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Black Disk',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Oxygen in Field',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Otara at Browns Bridge',
    widgetId: 5,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_otara_at_browns_bridge',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temperature',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_otara_at_browns_bridge',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_otara_at_browns_bridge',
        analyteIdentifier: 'black-disk',
        valueField: 'avg',
        label: 'Black Disk',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_otara_at_browns_bridge',
        analyteIdentifier: 'dissolved-oxygen-in-field',
        valueField: 'avg',
        label: 'Dissolved Oxygen in Field',
      },
    ],
  },
};

export const AnalyteWaiOpotikiHarbour: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Black\nDisk\nm',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Dissolved\nOxygen\ng/m³',
        position: 'right',
        offset: 45,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temperature',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Black Disk',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Oxygen in Field',
      },
    ],
  },
  dataConfig: {
    title: 'Analyte WAI - Field Water Sampling: Coastal Ōpōtiki Harbour',
    widgetId: 6,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temperature',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'black-disk',
        valueField: 'avg',
        label: 'Black Disk',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_opotiki_estuary_at_kukumoa',
        analyteIdentifier: 'dissolved-oxygen-in-field',
        valueField: 'avg',
        label: 'Dissolved Oxygen in Field',
      },
    ],
  },
};
